import clsx from "clsx";
import { useLocale } from "hooks";
import React, { useState, useEffect } from "react";
import Image from "components/Image";

const PersonCard: FC = ({ user, isVisible, isMobileView }) => {
  const { isRTL } = useLocale();
  return (
    <div
      className={clsx(
        "md:tw-h-[unset] tw-rounded-xl tw-border tw-border-solid tw-border-[#E5E9F4] tw-bg-[#E0F2F9] tw-relative md:tw-absolute md:tw-items-center tw-min-w-max",
        {
          "md:tw-flex": isVisible,
          "md:group-hover:tw-flex tw-hidden": !isVisible,
        },
        {
          "md:tw-left-[170px] lg:tw-left-[330px]": isRTL,
          "md:tw-right-[170px] lg:tw-right-[330px]": !isRTL,
        },
        {
          "!tw-block": isMobileView,
        }
      )}
    >
      <svg
        style={{ rotate: `${isRTL ? 0 : 180}deg` }}
        className={clsx("tw-hidden md:tw-block tw-absolute", {
          "md:tw-left-[-14px]": isRTL,
          "md:tw-right-[-14px]": !isRTL,
        })}
        width="15"
        height="23"
        viewBox="0 0 15 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.51791 9.25598C0.295582 10.4783 0.295582 12.4601 1.51791 13.6824L9.61136 21.7759C11.5831 23.7476 14.9546 22.3512 14.9546 19.5626V3.37576C14.9546 0.587249 11.5831 -0.809239 9.61136 1.16253L1.51791 9.25598Z"
          fill="#E0F2F9"
        />
      </svg>
      <div className="tw-flex tw-w-full tw-justify-center tw-absolute md:tw-hidden -tw-bottom-3">
        <svg
          width="23"
          height="15"
          viewBox="0 0 23 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.43664 13.4367C10.659 14.659 12.6408 14.659 13.8631 13.4367L21.9565 5.34323C23.9283 3.37146 22.5318 3.52859e-05 19.7433 3.52859e-05L3.55642 3.52859e-05C0.767913 3.52859e-05 -0.628575 3.37146 1.3432 5.34323L9.43664 13.4367Z"
            fill="#E0F2F9"
          />
        </svg>
      </div>

      <div className="tw-p-2.5">
        <div className="tw-overflow-hidden tw-rounded-md md:tw-aspect-square">
          <Image
            src={user.image}
            width={150}
            height={150}
            className="tw-rounded-full tw-w-[96px] tw-h-[96px]"
            alt={user.alt || user.image}
            loading="eager"
          />
        </div>
      </div>
      <div className="tw-p-4 tw-w-full tw-h-[140px] tw-flex tw-flex-col tw-justify-between tw-text-start">
        <h6 className="tw-text-sm xxxl:tw-text-base tw-font-medium tw-text-[#154875]">
          {user.title}
        </h6>
        {user?.email && (
          <p className="tw-text-xs tw-text-[#334155] tw-flex tw-items-center">
            <svg
              width="20"
              height="19"
              viewBox="0 0 20 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.7169 2.84882H5.89196C3.54448 2.84882 1.97949 4.02256 1.97949 6.76128V12.2387C1.97949 14.9775 3.54448 16.1512 5.89196 16.1512H13.7169C16.0644 16.1512 17.6294 14.9775 17.6294 12.2387V6.76128C17.6294 4.02256 16.0644 2.84882 13.7169 2.84882ZM14.0847 7.6142L11.6355 9.57043C11.119 9.98516 10.4617 10.1886 9.80443 10.1886C9.14713 10.1886 8.48201 9.98516 7.97339 9.57043L5.52419 7.6142C5.27379 7.41075 5.23466 7.03516 5.43029 6.78476C5.63374 6.53436 6.00151 6.48741 6.25191 6.69086L8.70111 8.64709C9.2958 9.12441 10.3052 9.12441 10.8999 8.64709L13.3491 6.69086C13.5995 6.48741 13.9751 6.52653 14.1707 6.78476C14.3742 7.03516 14.3351 7.41075 14.0847 7.6142Z"
                fill="#64748B"
              />
            </svg>
            <a
              href={`mailto:${user.email}`}
              className={clsx({ "tw-mr-1": isRTL, "tw-ml-1": !isRTL })}
            >
              {user.email}
            </a>
          </p>
        )}
        {user.location && (
          <p className="tw-flex tw-items-center tw-text-xs tw-text-[#334155]">
            <svg
              width="20"
              height="19"
              viewBox="0 0 20 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.5501 6.72214C15.7284 3.10702 12.575 1.47943 9.80497 1.47943C9.80497 1.47943 9.80497 1.47943 9.79714 1.47943C7.03494 1.47943 3.87367 3.09919 3.05205 6.71431C2.13653 10.752 4.60921 14.1715 6.84714 16.3233C7.67659 17.1215 8.74078 17.5205 9.80497 17.5205C10.8692 17.5205 11.9334 17.1215 12.755 16.3233C14.9929 14.1715 17.4656 10.7598 16.5501 6.72214ZM9.80497 10.6424C8.44343 10.6424 7.34012 9.53911 7.34012 8.17758C7.34012 6.81604 8.44343 5.71272 9.80497 5.71272C11.1665 5.71272 12.2698 6.81604 12.2698 8.17758C12.2698 9.53911 11.1665 10.6424 9.80497 10.6424Z"
                fill="#64748B"
              />
            </svg>
            <span className={clsx({ "tw-mr-1": isRTL, "tw-ml-1": !isRTL })}>
              {user.location}
            </span>
          </p>
        )}
        {user.phone && (
          <p className="tw-flex tw-items-center tw-text-xs tw-text-[#334155]">
            <svg
              width="20"
              height="19"
              viewBox="0 0 20 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.06106 11.8085L7.61344 13.2561C7.30827 13.5612 6.82313 13.5612 6.51013 13.2639C6.42405 13.1778 6.33798 13.0996 6.25191 13.0135C5.44594 12.1997 4.71822 11.3468 4.06875 10.4547C3.42711 9.5627 2.91066 8.67066 2.53506 7.78644C2.16729 6.8944 1.97949 6.04148 1.97949 5.22769C1.97949 4.6956 2.07339 4.18697 2.26119 3.71748C2.44899 3.24016 2.74634 2.80196 3.16106 2.41071C3.66185 1.91774 4.2096 1.67517 4.78864 1.67517C5.00774 1.67517 5.22684 1.72212 5.42246 1.81602C5.62591 1.90992 5.80589 2.05077 5.94673 2.25422L7.76212 4.81297C7.90297 5.00859 8.00469 5.18857 8.07512 5.36071C8.14554 5.52504 8.18467 5.68936 8.18467 5.83804C8.18467 6.02583 8.12989 6.21363 8.02034 6.39361C7.91862 6.57358 7.76994 6.76138 7.58214 6.94918L6.98745 7.56735C6.90138 7.65342 6.86225 7.75514 6.86225 7.88034C6.86225 7.94294 6.87008 7.99772 6.88573 8.06032C6.9092 8.12292 6.93268 8.16987 6.94833 8.21681C7.08917 8.47504 7.33175 8.81151 7.67604 9.21841C8.02817 9.6253 8.40376 10.04 8.81066 10.4547C8.88891 10.533 8.97498 10.6112 9.05323 10.6895C9.36623 10.9947 9.37405 11.4955 9.06106 11.8085Z"
                fill="#64748B"
              />
              <path
                d="M17.6072 14.4533C17.6072 14.6724 17.5681 14.8994 17.4898 15.1185C17.4663 15.1811 17.4429 15.2437 17.4116 15.3063C17.2785 15.5879 17.1064 15.854 16.8795 16.1044C16.496 16.5269 16.0735 16.8321 15.5962 17.0277C15.5883 17.0277 15.5805 17.0356 15.5727 17.0356C15.111 17.2234 14.6102 17.3251 14.0703 17.3251C13.2722 17.3251 12.4192 17.1373 11.5194 16.7539C10.6195 16.3704 9.71964 15.854 8.8276 15.2045C8.52243 14.9776 8.21726 14.7507 7.92773 14.5081L10.4865 11.9494C10.7056 12.1137 10.9012 12.2389 11.0655 12.325C11.1047 12.3406 11.1516 12.3641 11.2064 12.3875C11.269 12.411 11.3316 12.4188 11.402 12.4188C11.535 12.4188 11.6368 12.3719 11.7228 12.2858L12.3175 11.699C12.5131 11.5033 12.7009 11.3547 12.8809 11.2608C13.0609 11.1512 13.2409 11.0964 13.4365 11.0964C13.5852 11.0964 13.7417 11.1277 13.9138 11.1982C14.086 11.2686 14.2659 11.3703 14.4616 11.5033L17.0516 13.3422C17.2551 13.483 17.3959 13.6474 17.482 13.843C17.5602 14.0386 17.6072 14.2342 17.6072 14.4533Z"
                fill="#64748B"
              />
            </svg>
            <a
              href={`phone:${user.phone}`}
              className={clsx({ "tw-mr-1": isRTL, "tw-ml-1": !isRTL })}
            >
              {user.phone}
            </a>
          </p>
        )}
      </div>
    </div>
  );
};

const CustomChart = ({ parentWithChildren, tabData }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 744);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const DesktopView = () => {
    const { isRTL } = useLocale();

    const [isCardPinned, setIsCardPinned] = useState(false);

    useEffect(() => {
      const handleClickOutside = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (!target.closest(".person-card-group")) {
          setIsCardPinned(false);
        }
      };

      if (isCardPinned) {
        document.addEventListener("click", handleClickOutside);
      }

      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, [isCardPinned]);

    return (
      <div className="tw-flex tw-flex-col tw-items-center tw-w-full tw-p-8">
        <div
          className={clsx("tw-relative", {
            "tw-cursor-pointer": Boolean(tabData?.user?.title),
          })}
        >
          <div
            className={clsx(
              "tw-rounded-lg tw-shadow-lg tw-px-2 md:tw-px-4 tw-max-w-[310px] tw-min-w-[310px] tw-h-20 tw-flex tw-items-center tw-justify-center tw-group person-card-group",
              {
                "tw-bg-[#007FAC] tw-text-white":
                  +tabData?.tagtreeId === +parentWithChildren?.id,
                "tw-bg-[#E2E8F0] tw-text-[#334155]":
                  +tabData?.tagtreeId !== +parentWithChildren?.id,
              }
            )}
            onClick={() => setIsCardPinned((prev) => !prev)} // کلیک = پین/آنپین
          >
            <h2 className="tw-text-lg tw-font-bold tw-text-center">
              {parentWithChildren?.title}
            </h2>

            {/* PersonCard فقط وقتی نشون بشه که یا hover باشه یا پین شده باشه */}
            {tabData?.user?.title && (
              <PersonCard
                user={tabData.user}
                isVisible={isCardPinned} // این prop رو به PersonCard می‌فرستیم
              />
            )}
          </div>
          {parentWithChildren?.children?.length > 0 && (
            <div className="tw-absolute -tw-bottom-10 tw-left-1/2 tw-transform -tw-translate-x-1/2 tw-translate-y-full tw-w-0.5 tw-h-10 tw-bg-[#94A3B8]"></div>
          )}
        </div>

        {parentWithChildren?.children?.length > 0 && (
          <div className="tw-h-14"></div>
        )}

        {parentWithChildren?.children?.length > 0 && (
          <div className="tw-relative tw-flex tw-items-start tw-gap-4">
            {parentWithChildren?.children?.length > 1 && (
              <div
                className={clsx(
                  "tw-absolute tw-h-0.5 tw-bg-[#94A3B8] tw-top-[-18px] lg:tw-left-[123px] lg:tw-right-[121px]",
                  {
                    "tw-left-[59px] tw-right-[57px]":
                      parentWithChildren?.children?.length === 5 && isRTL,
                    "tw-left-[72px] tw-right-[70px]":
                      parentWithChildren?.children?.length !== 5 && isRTL,
                    "tw-left-[63px] tw-right-[61px]":
                      parentWithChildren?.children?.length === 5 && !isRTL,
                    "tw-left-[72px] tw-right-[63px]":
                      parentWithChildren?.children?.length === 3 && !isRTL,
                    "tw-left-[66px] tw-right-[70px]":
                      [2, 4].includes(parentWithChildren?.children?.length) &&
                      !isRTL,
                  }
                )}
              />
            )}

            {parentWithChildren?.children?.map((child, index) => (
              <div
                key={child?.id}
                className="tw-relative tw-flex tw-flex-col tw-items-center"
              >
                <div
                  className={
                    "tw-absolute -tw-top-4 tw-left-1/2 tw-transform -tw-translate-x-1/2 tw-w-0.5 tw-h-10 tw-bg-[#94A3B8]"
                  }
                ></div>
                <div
                  className={clsx(
                    "tw-px-2 md:tw-px-4 tw-py-3 tw-rounded-lg tw-shadow-md tw-text-center tw-max-w-[144px] lg:tw-max-w-[246px] tw-max-min-[144px] lg:tw-min-w-[246px] tw-h-20 tw-flex tw-items-center tw-justify-center tw-mt-6",
                    {
                      "tw-bg-[#007FAC] tw-text-white":
                        +tabData.tagtreeId === +child.id,
                      "tw-bg-[#F1F5F9] tw-text-[#113E66]":
                        +tabData.tagtreeId !== +child.id,
                    }
                  )}
                >
                  <p className="tw-text-sm tw-font-medium">{child?.title}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  // Mobile View Component
  const MobileView = () => {
    const { isRTL } = useLocale();
    return (
      <div className="tw-flex tw-flex-col tw-flex-1 tw-mt-8">
        <div
          className={clsx(
            "tw-text-white tw-px-6 tw-py-4 tw-rounded-lg tw-shadow-lg tw-mb-6 tw-h-20 tw-flex tw-items-center tw-justify-center",
            {
              "tw-bg-[#007FAC] tw-text-white":
                +tabData?.tagtreeId === +parentWithChildren?.id,
              "tw-bg-[#E2E8F0] tw-text-[#334155]":
                +tabData?.tagtreeId !== +parentWithChildren?.id,
            }
          )}
        >
          <h2 className="tw-text-base tw-font-bold tw-text-center">
            {parentWithChildren?.title}
          </h2>
        </div>

        <div
          className={clsx("tw-relative", {
            "tw-pr-8": isRTL,
            "tw-pl-8": !isRTL,
          })}
        >
          <div
            className={clsx(
              "tw-absolute -tw-top-6 tw-bottom-[2.5rem] tw-w-0.5 tw-bg-[#94A3B8]",
              { "tw-right-8": isRTL, "tw-left-8": !isRTL }
            )}
          ></div>

          <div className="tw-space-y-4">
            {parentWithChildren?.children?.map((child) => (
              <div
                key={child?.id}
                className="tw-relative tw-flex tw-items-center"
              >
                <div
                  className={clsx(
                    "tw-absolute tw-w-8 tw-h-0.5 tw-bg-[#94A3B8]",
                    { "tw-right-0": isRTL, "tw-left-0": !isRTL }
                  )}
                ></div>

                <div
                  className={clsx(
                    "tw-px-4 tw-py-3 tw-rounded-lg tw-shadow-md tw-flex-1 tw-h-20 tw-flex tw-items-center",
                    {
                      "tw-bg-[#007FAC] tw-text-white":
                        +tabData.tagtreeId === +child.id,
                      "tw-bg-[#F1F5F9] tw-text-[#113E66]":
                        +tabData?.tagtreeId !== +child?.id,
                      "tw-mr-8": isRTL,
                      "tw-ml-8": !isRTL,
                    }
                  )}
                >
                  <p className="tw-text-sm tw-font-medium">{child?.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  if (parentWithChildren?.title) {
    return (
      <div style={{ direction: "rtl" }}>
        <div className="tw-mx-auto">
          {isMobile ? (
            <>
              {tabData?.user?.title && (
                <PersonCard user={tabData.user} isMobileView={true} />
              )}
              <MobileView />
            </>
          ) : (
            <DesktopView />
          )}
        </div>
      </div>
    );
  }
  return "";
};

export default CustomChart;
